import { push } from 'connected-react-router';

import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const ADD_ONLINE_FORM_REQUEST = 'ADD_ONLINE_FORM_REQUEST';
export const ADD_ONLINE_FORM_SUCCESS = 'ADD_ONLINE_FORM_SUCCESS';
export const ADD_ONLINE_FORM_FAILURE = 'ADD_ONLINE_FORM_FAILURE';

function requestAddOnlineForm() {
  return {
    type: ADD_ONLINE_FORM_REQUEST,
    isAddingOnlineForm: true
  };
}

function receiveAddOnlineForm(addingFormResults) {
  return {
    type: ADD_ONLINE_FORM_SUCCESS,
    isAddingOnlineForm: false,
    addingFormResults
  };
}

function rejectAddOnlineForm(addingFormResults) {
  return {
    type: ADD_ONLINE_FORM_FAILURE,
    isAddingOnlineForm: false,
    addingFormResults
  };
}

export function addOnlineForm(formType, clientId, legalEntity, customer, whdAgents, formReference) {
  const formCategory = formType.includes('crs') || formType.startsWith('rc') ? 'crs' : 'w';

  const postData = {
    isOnline: true,
    client: clientId,
    legalEntity: legalEntity.id,
    whdAgents,
    wForm: formCategory === 'w' ? {
      customer: customer.id,
      type: formType
    } : null,
    crsForm: formCategory === 'crs' ? {
      customer: customer.id,
      type: formType
    } : null,
    wFormReference: formCategory === 'w' ? formReference : null,
    crsFormReference: formCategory === 'crs' ? formReference : null
  };

  return (dispatch) => {
    dispatch(requestAddOnlineForm());

    const promise = () => ApiService
      .addForm(postData)
      .then((response) => {
        if (response.data.redirectUrl) {
          return dispatch(push(response.data.redirectUrl));
        }
        return dispatch(receiveAddOnlineForm(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAddOnlineForm));
        }
      });
    return promise();
  };
}
